import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "./tracker";

/** 公開ページの表示を記録する（管理画面・プレビューでは tracker 側で何もしない） */
export const AnalyticsTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    trackPageview(pathname);
  }, [pathname]);
  return null;
};
